<ng-container *sm-has-env-flag="'auroraV1'">
    @if (showAvatar()) {
        <aurora-avatar
            id="notificationAvatar"
            size="small"
            [user]="toAuroraAvatarUser(vm?.OriginatorBadge | async)"
            [showTooltip]="false">
        </aurora-avatar>
    } @else {
        <unity-icon [icon]="getAvatarIcon()" size="large"/>
    }

    <h2 id="notificationTitle">{{ vm?.Message }}</h2>

    <div *ngIf="!vm?.IsMarkedForDelete" class="time_actions">
        <sm-time-since class="card-title-time-since" [start]="vm?.CreatedOnDate"></sm-time-since>
        <aurora-icon-button
            id="deleteNotification"
            (click)="onDeleteNotification()"
            icon="trash"
            size="large"
            label="Delete notification">
        </aurora-icon-button>
    </div>

    <aurora-link-button id="undoDeleteNotification" *ngIf="vm?.IsMarkedForDelete" size="small" iconRight="undo" class="undo" (click)="onUndoDelete()">
        undo delete
    </aurora-link-button>

    <ng-container *ngFor="let subtitle of vm.Subtitles">
        <div *ngIf="!vm?.IsMarkedForDelete" id="notificationEntity" class="subline">
            {{ subtitle?.DisplayEntityType ?? subtitle?.EntityType }}:
            @if (subtitle?.IsLink) {
                @if (subtitle.EntityType == 'Email') {
                    <aurora-link-button
                        [id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                        size="small"
                        prominence="low"
                        (click)="openMailTo(subtitle?.EntityText)">
                        {{subtitle?.EntityText || 'Email ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}
                    </aurora-link-button>
                } @else {
                    <aurora-link-button
                        [id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                        size="small"
                        prominence="low"
                        (click)="onClickLink.emit(vm)">
                        @if (subtitle.EntityType == 'Download') {
                            file
                        } @else {
                            {{subtitle?.EntityText || 'Go to ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}

                        }
                    </aurora-link-button>
                }

            } @else {
                {{subtitle?.EntityText}}
            }

        </div>
    </ng-container>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    @if (showAvatar()) {
        <unity-avatar id="notificationAvatar" [model]="(vm?.OriginatorBadge | async)" size="small"></unity-avatar>
    } @else {
        <unity-icon [icon]="getAvatarIcon()" size="large"/>
    }

    <h2 id="notificationTitle">{{ vm?.Message }}</h2>

    <div *ngIf="!vm?.IsMarkedForDelete" class="time_actions">
        <sm-time-since class="card-title-time-since" [start]="vm?.CreatedOnDate"></sm-time-since>
        <button id="deleteNotification" unity-button class="icon-only small" (click)="onDeleteNotification()">
            <svg class="unity-icon-trash">
                <use xlink:href="#unity-icon-trash"></use>
            </svg>
        </button>
    </div>

    <button id="undoDeleteNotification" unity-button *ngIf="vm?.IsMarkedForDelete" class="link small undo" (click)="onUndoDelete()">
        undo delete
        <svg class="unity-icon-undo">
            <use xlink:href="#unity-icon-undo"></use>
        </svg>
    </button>

    <ng-container *ngFor="let subtitle of vm.Subtitles">
        <div *ngIf="!vm?.IsMarkedForDelete" id="notificationEntity" class="subline">
            {{ subtitle?.DisplayEntityType ?? subtitle?.EntityType }}:
            @if (subtitle?.IsLink) {
                @if (subtitle.EntityType == 'Email') {
                    <a
                        unity-button
                        [id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                        class="link secondary"
                        href="mailto:{{subtitle.EntityText}}"
                    >
                        {{subtitle?.EntityText || 'Email ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}
                    </a>
                } @else {
                    <button
                        unity-button
                        [id]="'notificationEntityLink:' + subtitle.EntityType + ':' + subtitle.EntityId"
                        class="link secondary"
                        (click)="onClickLink.emit(vm)"
                    >
                        @if (subtitle.EntityType == 'Download') {
                            file
                        } @else {
                            {{subtitle?.EntityText || 'Go to ' + (subtitle?.DisplayEntityType ?? subtitle?.EntityType) }}

                        }
                    </button>
                }

            } @else {
                {{subtitle?.EntityText}}
            }

        </div>
    </ng-container>
</ng-container>

<div
    *ngIf="vm?.Description && !vm?.IsMarkedForDelete"
    class="description" [ngClass]="{ 'overflow': needsShowMoreShowLess}"
    [class.collapsed]="isCollapsed"
    [class.overflow]="isOverflow"
    (click)="toggleDescription()"
>
    <span id="notificationDescription">{{vm?.Description}}</span>
</div>
